import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { usePropertyRentalIsLoanProceedsUsedPropertyImprovements } from '../../../../queries/PropertyFields/RentalFlagFields';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

interface LoanProceedPropertyImprovementRentalProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const LoanProceedPropertyImprovementRental: React.FC<LoanProceedPropertyImprovementRentalProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'Will loan proceeds be used to improve the property?';
    const [isLoanProceedPropertyImprovementRental, set_isLoanProceedPropertyImprovementRental] =
        usePropertyRentalIsLoanProceedsUsedPropertyImprovements(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        set_isLoanProceedPropertyImprovementRental(e.itemData?.id === 'Yes');
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={isLoanProceedPropertyImprovementRental ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='loanProceedPropertyImprovementRental'
                    value={isLoanProceedPropertyImprovementRental}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='This field is required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
